"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsRespository = void 0;
const subscriptions_1 = require("./subscriptions");
/**
 * Repository of settings that are synced with a storage container.
 */
class SettingsRespository {
    /**
     * @param options Configurable options
     */
    constructor(options) {
        /** Subscription manager for these settings. */
        this.subscriptions = new subscriptions_1.SubscriptionManager();
        // creating settings object
        const settings = {};
        for (const settingName in options.settings) {
            const builder = options.settings[settingName];
            settings[settingName] = new builder.type(builder.defaultValue, builder.callbacks);
        }
        // wrapping settings in a proxy
        const subManager = this.subscriptions;
        const storageKey = (prop) => `${options.prefix ?? ""}${prop}`;
        this.settings = new Proxy(settings, {
            get(target, prop) {
                const raw = options.storage.getItem(storageKey(prop));
                return target[prop].decode(raw);
            },
            set(target, prop, value) {
                const raw = target[prop].encode(value);
                options.storage.setItem(storageKey(prop), raw);
                target[prop].handleChange(value);
                subManager.notifySubscribers(prop, value);
                return true;
            },
            deleteProperty(target, prop) {
                options.storage.removeItem(storageKey(prop));
                target[prop].handleChange(undefined);
                subManager.notifySubscribers(prop, undefined);
                return true;
            }
        });
    }
}
exports.SettingsRespository = SettingsRespository;
